export default __webpack_public_path__ + "static/media/0634bf2356daf8c2a25a31c9a95c509e.png";